import React from 'react'

export const makeHoverable = (hoverableProps = {}) => OriginalComponent => {
  class MakingHoverable extends React.Component {
    state = {
      isHovered: false,
    }

    setIsHovered = isHovered => {
      this.setState({ isHovered })
    }

    onMouseOver = event => {
      if (this.state.isHovered) {
        return
      }
      if (!hoverableProps.onMouseOver) {
        this.setIsHovered(true)
      } else {
        hoverableProps.onMouseOver(event, this.setIsHovered)
      }
    }

    onMouseLeave = event => {
      if (!this.state.isHovered) {
        return
      }
      this.setIsHovered(false)
    }

    render() {
      return React.createElement(
        OriginalComponent,
        {
          isHovered: this.state.isHovered,
          onMouseOver: this.onMouseOver,
          onMouseLeave: this.onMouseLeave,
          ...this.props,
        },
        this.props.children
      )
    }
  }
  return MakingHoverable
}

export const Hoverable = (hoverableProps = {}) => OriginalComponent => {
  const Hoverable = ({
    isHovered,
    onMouseOver,
    onMouseLeave,
    children,
    ...originalProps
  }) => {
    return React.createElement(
      'div',
      { onMouseOver, onMouseLeave },
      React.createElement(
        OriginalComponent,
        {
          isHovered,
          ...originalProps,
        },
        children
      )
    )
  }
  return makeHoverable(hoverableProps)(Hoverable)
}
